import { CustomerRole } from 'components/customers/models/Customer';
import { ICreateCustomerExportOptions, ICustomerExportFilters } from '../models';

export interface ExportFormValues {
    role: string;
    hasAgreedToReceiveMarketing: string;
    createdAfter: Date | null;
    updatedAfter: Date | null;
}

export const INITIAL_EXPORT_VALUES: ExportFormValues = {
    role: 'ALL',
    hasAgreedToReceiveMarketing: 'ALL',
    createdAfter: null,
    updatedAfter: null
};

export function getCustomersExportOptions(filters: ExportFormValues): ICreateCustomerExportOptions {
    const exportFilters: ICustomerExportFilters = {};

    if (filters.hasAgreedToReceiveMarketing === 'true' || filters.hasAgreedToReceiveMarketing === 'false') {
        exportFilters.hasAgreedToReceiveMarketing = filters.hasAgreedToReceiveMarketing === 'true';
    }

    if (filters.role === CustomerRole.USER || filters.role === CustomerRole.GUEST) {
        exportFilters.role = filters.role;
    }

    if (filters.createdAfter) {
        exportFilters.createdAfter = filters.createdAfter.toISOString();
    }

    if (filters.updatedAfter) {
        exportFilters.updatedAfter = filters.updatedAfter.toISOString();
    }

    return {
        filters: Object.keys(exportFilters).length > 0 ? exportFilters : undefined
    };
}
